<template>
  <div class="nps-display">
    <div class="nps-chart">
      <radial-progress-bar
        v-if="nps !== null && nps !== undefined"
        :diameter="300"
        :stroke-width="20"
        innerStrokeColor="#f1f1f1"
        :startColor="colorBalance"
        :stopColor="colorBalance"
        :completed-steps="completedSteps ? parseFloat(completedSteps) : 0"
        :total-steps="totalSteps"
      >
        <b
          id="number-nps"
          :style="{
            color: colorBalance,
            fontSize: '3em',
            fontWeight: 'bold',
          }"
          >{{ completedSteps }}</b
        >
        <b-tooltip
          v-if="nps !== null && nps !== undefined"
          target="number-nps"
          placement="bottom"
        >
          {{ toolTipMsg }}
          <strong>{{ nps.toFixed(2) }}</strong>
        </b-tooltip>
      </radial-progress-bar>
      <div v-else>{{ this.$t('reports.npsBar.noDataMsg') }}</div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import RadialProgressBar from 'vue-radial-progress';
import animatedNumber from 'animated-number-vue';
import EventBus from '../../../../eventBus';
import api from '../../../../services/api'

export default {
  name: 'npsBarPanel',
  components: {
    RadialProgressBar,
    animatedNumber,
  },

  props: ['dataGraph'],

  data: () => ({
    userAuth: null,
    completedSteps: null,
    totalSteps: 100,
    colorBalance: '#fff',
    toolTipMsg: '',
    reportTitle: '',
    nps: null
  }),
  watch: {
  },
  computed: {
    ...mapState('actions', ['myActionId', 'actionGroupData']),
    ...mapState('branches', ['myIh1', 'myIh2']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['myMetric']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },
  methods: {
    ...mapActions('dashboard', ['getMetricValue', 'getNpsByDate']),
    ...mapActions('calendar', ['setDefaultDates']),
    formatToPrice(value) {
      if (value) {
        return value.toFixed(0);
      }
      return 0;
    },
    setColorNps(percentBalace) {
      if (this.dataGraph.metric.indexOf('nps') !== -1) {
        if (percentBalace >= 80) {
          this.colorBalance = '#6bca6c';
        } else if (percentBalace < 80 && percentBalace >= 70) {
          this.colorBalance = '#9fd77a';
        } else if (percentBalace < 70 && percentBalace >= 50) {
          this.colorBalance = '#fbcf3f';
        } else if (percentBalace < 50 && percentBalace >= 0) {
          this.colorBalance = '#fa834f';
        } else if (percentBalace < 0) {
          this.colorBalance = 'red';
        }
      } else if (this.dataGraph.metric.indexOf('ces') !== -1) {
        if (percentBalace >= 4) {
          this.colorBalance = '#6bca6c';
        } else if (percentBalace < 4 && percentBalace >= 3) {
          this.colorBalance = '#9fd77a';
        } else if (percentBalace < 3 && percentBalace >= 2) {
          this.colorBalance = '#fbcf3f';
        } else if (percentBalace < 2 && percentBalace >= 1) {
          this.colorBalance = '#fa834f';
        } else if (percentBalace <= 1) {
          this.colorBalance = 'red';
        }
      } else if (this.dataGraph.metric.indexOf('csat') !== -1) {
        if (percentBalace >= 4) {
          this.colorBalance = '#6bca6c';
        } else if (percentBalace < 4 && percentBalace >= 3) {
          this.colorBalance = '#9fd77a';
        } else if (percentBalace < 3 && percentBalace >= 2) {
          this.colorBalance = '#fbcf3f';
        } else if (percentBalace < 2 && percentBalace >= 1) {
          this.colorBalance = '#fa834f';
        } else if (percentBalace < 1) {
          this.colorBalance = 'red';
        }
      } else if (this.dataGraph.metric.indexOf('stars') !== -1) {
        if (percentBalace >= 4) {
          this.colorBalance = '#6bca6c';
        } else if (percentBalace < 4 && percentBalace >= 3) {
          this.colorBalance = '#9fd77a';
        } else if (percentBalace < 3 && percentBalace >= 2) {
          this.colorBalance = '#fbcf3f';
        } else if (percentBalace < 2 && percentBalace >= 1) {
          this.colorBalance = '#fa834f';
        } else if (percentBalace < 1) {
          this.colorBalance = 'red';
        }
      } else if (this.dataGraph.metric.indexOf('like-dislike') !== -1) {
        if (percentBalace >= 4) {
          this.colorBalance = '#6bca6c';
        } else if (percentBalace < 4 && percentBalace >= 3) {
          this.colorBalance = '#9fd77a';
        } else if (percentBalace < 3 && percentBalace >= 2) {
          this.colorBalance = '#fbcf3f';
        } else if (percentBalace < 2 && percentBalace >= 1) {
          this.colorBalance = '#fa834f';
        } else if (percentBalace < 1) {
          this.colorBalance = 'red';
        }
      }
    },
    changeLabel() {
      if (this.dataGraph.metric.indexOf('nps') !== -1) {
        this.totalSteps = 100;
        this.toolTipMsg = this.$t('reports.npsBar.npsMessage');
        this.reportTitle = this.$t('reports.npsBar.reportTitle');
      } else if (this.dataGraph.metric.indexOf('ces') !== -1) {
        this.totalSteps = 5;
        this.toolTipMsg = this.$t('reports.npsBar.cesMessage');
        this.reportTitle = this.$t('reports.npsBar.cesReportTitle');
      } else if (this.dataGraph.metric === 'csat-1-5') {
        this.totalSteps = 100;
        this.toolTipMsg = this.$t('reports.npsBar.csatMessage');
        this.reportTitle = this.$t('reports.npsBar.csatReportTitle');
      } else if (this.dataGraph.metric === 'csat-1-5(media)') {
        this.totalSteps = 5;
        this.toolTipMsg = this.$t('reports.npsBar.csatMessage');
        this.reportTitle = this.$t('reports.npsBar.csatAverageReportTitle');
      } else if (this.dataGraph.metric === 'csat-0-10(media)') {
        this.totalSteps = 10;
        this.toolTipMsg = this.$t('reports.npsBar.csatMessage');
        this.reportTitle = this.$t('reports.npsBar.csat0to10ReportTitle');
      } else if (this.dataGraph.metric === '5-stars') {
        this.totalSteps = 5;
        this.toolTipMsg = this.$t('reports.npsBar.fiveStarsMessage');
        this.reportTitle = this.$t('reports.npsBar.fiveStarsReportTitle');
      } else if (this.dataGraph.metric.indexOf('like-dislike') !== -1) {
        this.totalSteps = 100;
        this.toolTipMsg = this.$t('reports.npsBar.likeDislikeMessage');
        this.reportTitle = this.$t('reports.npsBar.likeDislikeReportTitle');
      }
    },

    async getData(){
      const response = await api.get(
        `${process.env.API_ROOT}/metrics-panel/${this.userAuth.companyId}`,
        {
          headers: { 'x-access-token': this.userAuth.token },
          params: {
              companyId: this.userAuth.companyId,
              actionId: this.dataGraph.actionId ? this.dataGraph.actionId._id : null,
              ih1: this.dataGraph.ih1 && this.dataGraph.ih1.length > 0 ? this.dataGraph.ih1.map((item) => item._id): null,
              metric: this.dataGraph.metric,
              groupId: this.dataGraph.actionGroupId ? this.dataGraph.actionGroupId._id : null,
              indicator: this.dataGraph.indicator ? this.dataGraph.indicator : null,
              indicatorValue: this.dataGraph.valueIndicator,
              period: this.dataGraph.period,
              _id: this.dataGraph._id,
            },
          },
      );

      this.nps = response.data.nps;

      this.setColorNps(response.data.nps);

      if (this.dataGraph.metric.indexOf('nps') !== -1) {
        this.completedSteps = response.data.nps.toFixed(1);
      } else if (this.dataGraph.metric.indexOf('ces') !== -1) {
        this.completedSteps = response.data.nps.toFixed(2);
      } else if (this.dataGraph.metric.indexOf('csat') !== -1) {
        this.completedSteps = response.data.nps.toFixed(1);
      } else if (this.dataGraph.metric.indexOf('stars') !== -1) {
        this.completedSteps = response.data.nps.toFixed(1);
      } else if (this.dataGraph.metric.indexOf('like-dislike') !== -1) {
        this.completedSteps = response.data.nps.toFixed(1);
      }
      EventBus.$emit('load-nps');
    }
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },

  mounted() {
    this.changeLabel();

    this.getData();

    EventBus.$on('refresh', async () => {
      this.setDefaultDates();
      this.getData();
    });
  },
  beforeDestroy() {
    EventBus.$off('refresh');
  },
};
</script>

<style scoped lang="scss">
@import '@/themes/default/variables.scss';
@import '@/themes/default/placeholders.scss';
@import '@/themes/default/mixins.scss';

.radial-progress-inner {
  justify-content: center;
  font-size: 3.2em;
  cursor: pointer;
}
.nps-display {
  border: 1px solid #fff;
  padding: 18px 0;
  flex-direction: column;
  margin-top: 15px;
  border-radius: 4px;
  background-color: $white;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 350px;
  .idx-card-title {
    height: 30px;
    padding-left: 20px;
    text-align: left;
    width: 100%;
    font-weight: 100;
    color: #5f6368;
    font-size: 18px;
  }
  .nps-chart {
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(100% - 30px);
    margin-top: 10%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/nps-bar/panels/nps-bar.vue